import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageLineReport from '../../components/PageLineReport';

const KundenScoring = () => {
    return <PageLineReport title="Kunden-Scoring" reportCode={ReportCodes.CustomerScoring} roundDigits />;
};

export default KundenScoring;
